export class RecipeDetailScreenModel {
    /** レシピのID */
    recipeId: string | null = null;

    /** プレビュー or Not */
    isPreview: string | null | undefined = undefined;
}
